import React, { useEffect, useState } from 'react';
import { View, Text, Image, ScrollView, TouchableOpacity, FlatList } from 'react-native-web';
import * as Animatable from 'react-native-animatable';

// Child Components
import ResourceTopicItem from './component_topic_item';

// APIs
import { getResourceCategories } from '../../modules/api_resources';

// Utils
import { toTitleCase } from '../../utils/util_helpers';

// Configs
import GLOBAL from '../../configs/config_global';
import LoadingView from '../../components/component_loading_view';

// Animatable Comps
const AnimatableFlatList = Animatable.createAnimatableComponent(FlatList);

export function Resources() {
    // region Refs
    const DELAY_VALUE = 150;
    // endregion

    // region Local State
    const [isLoading, setLoading] = useState(false);
    const [resourceList, setResourceList] = useState([]);
    const [selectedResource, setSelectedResource] = useState(null);
    // endregion

    // region Component Mounting
    useEffect(() => {
        goFetchResources();
    }, []);
    // endregion

    // region Function - Get Resource Categories
    const goFetchResources = () => {
        setLoading(true);
        getResourceCategories()
            .then(setResourceList)
            .catch(() => setResourceList([]))
            .finally(() => setLoading(false));
    }
    // endregion

    // region Render Category Item
    const renderCategoryItem = (categoryData, index) => {
        const isChosen = selectedResource?.id === categoryData.id;
        return(
            <Animatable.View
                key={`categoryItem_${categoryData.id}`}
                animation={categoryData.isNew ? 'fadeInRight' : 'fadeInUp'} duration={600} delay={categoryData.isNew ? 0 : (index * DELAY_VALUE)}
                style={{ width: '100%', borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER }}>
                <TouchableOpacity
                    onPress={() => !isChosen && setSelectedResource(categoryData)}
                    style={{
                        width: '100%', alignItems: 'center', flexDirection: 'row',
                        paddingHorizontal: 24, paddingVertical: 20,
                        backgroundColor: isChosen ? GLOBAL.COLOR.MAIN_SELECTED : 'white'
                    }}>
                    {/* Order */}
                    <Image
                        source={require('../../images/iconResoures@3x.png')}
                        style={{ width: 32, height: 32 }}
                    />

                    {/* Name */}
                    <Text style={{ color: 'black', fontSize: 18, lineHeight: 26, fontWeight: '500', textAlign: 'left', marginLeft: 16 }} numberOfLines={2}>
                        {toTitleCase(categoryData.name)}
                    </Text>
                </TouchableOpacity>
            </Animatable.View>
        );
    }
    // endregion

    // region Render Main Content
    const renderContent = () => {
        const topicList = selectedResource?.['topics'] || [];
        return(
            <View style={{ flex: 1, width: '100%', flexDirection: 'row' }}>
                {/* Category */}
                <View style={{ width: '40%', minWidth: 350, maxWidth: 500, height: '100%' }}>
                    <ScrollView
                        style={{ flex: 1, width: '100%', backgroundColor: 'white' }}
                        showsVerticalScrollIndicator={false}>
                        {resourceList.map((item, index) => renderCategoryItem(item, index))}
                    </ScrollView>
                </View>

                {/* Items */}
                <View style={{ flex: 1 }}>
                    {
                        selectedResource ?
                            <AnimatableFlatList
                                animation={'fadeIn'}
                                style={{ flex: 1, width: '100%', backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }}
                                contentContainerStyle={{ paddingTop: 16, paddingBottom: 120 }}
                                data={topicList}
                                renderItem={({ item, index }) => <ResourceTopicItem topicData={item} index={index} />}
                                keyExtractor={(item) => item.id?.toString()}
                                ItemSeparatorComponent={() => <View style={{ height: 16, width: '100%', backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }} />}
                            />
                            :
                            <View style={{ flex: 1, width: '100%', alignItems: 'center', justifyContent: 'center', padding: 64 }}>
                                <Text style={{ color: GLOBAL.COLOR.TEXT_LIGHT_GRAY, textAlign: 'center' }}>
                                    Select a Resource Category
                                </Text>
                            </View>
                    }
                </View>
            </View>
        );
    }
    // endregion

    // region MAIN RENDER
    return(
        <View style={{ width: '100%', flex: 1, backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }}>
            {/* Nav Bar */}
            <View style={{
                flexDirection: 'row', width: '100%', alignItems: 'center',
                backgroundColor: 'white', borderBottomWidth: 1, borderBottomColor: GLOBAL.COLOR.DIVIDER,
                paddingVertical: 24, paddingHorizontal: 24
            }}>
                <Text style={{ fontSize: 28, fontWeight: '900' }}>
                    Vendor Resources
                </Text>
            </View>

            {/* Main Content */}
            {
                isLoading ?
                    <LoadingView style={{ backgroundColor: GLOBAL.COLOR.BACKGROUND_GREY }} />
                    :
                    (
                        resourceList.length > 0 ?
                            renderContent()
                            :
                            <View style={{ flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center', padding: 64 }}>
                                <Text style={{ color: GLOBAL.COLOR.TEXT_LIGHT_GRAY, textAlign: 'center' }}>
                                    No Vendor Resources Available
                                </Text>
                            </View>
                    )
            }
        </View>
    );
    // endregion
}
